/**
 * Full page reload. Wrapped in a module so the cross-tab "act like a refresh" path stays
 * unit-testable (jsdom's `window.location.reload` is non-configurable and can't be spied directly).
 */
export function reloadPage(): void {
  if (typeof window !== 'undefined') window.location.reload();
}
